import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const OS_FAMILY_VIDEO_REPORT_ID = `os-family${VIDEO_CAMPAIGN_SUFFIX}`;
